const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
  },
  content: {
    position: 'absolute',
    overflow: 'auto',
    top: '50%',
    left: '50%',
    bottom: 'auto',
    right: 'auto',
    width: 470,
    height: 150,
    padding: 0,
    transform: 'translate(-50%,-50%)',
    WebkitOverflowScrolling: 'touch',
    boxShadow: '0.33px 2px 8px rgba(0, 0, 0, 0.3)',
  },
};

export default styles;
